import * as React from 'react';
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import Editor from '@draft-js-plugins/editor'
import {convertFromHTML, convertToHTML} from 'draft-convert'

import { richButtonsPlugin, } from '../../../../Shared/index';

class MultipleTextEditor extends React.Component<any, any> {
  constructor(props) {
    super(props);
    const rbp = richButtonsPlugin();
    const InlineButton = ({className, toggleInlineStyle, isActive, label, inlineStyle, onMouseDown, title}) =>
      (<a onClick={toggleInlineStyle} onMouseDown={onMouseDown}>
        <span
          className={`${className}`}
          style={{ color: isActive ? '#990000' : '#777' }}
          title={title ? title : label}
        >{title}
        </span>
      </a>);
    const {
      ItalicButton, BoldButton, UnderlineButton,
      BlockquoteButton, OLButton, ULButton, H4Button, MonospaceButton
    } = rbp;
    this.state = {
      text: EditorState.createWithContent(convertFromHTML(this.props.text || '')),
      components: { ItalicButton, BoldButton, UnderlineButton, BlockquoteButton, OLButton, ULButton, H4Button, MonospaceButton, InlineButton},
      plugins: [rbp],
      hasFocus: false,
    };
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { text, lessonPrompt, boilerplate, handleTextChange } = this.props
    if (text !== prevProps.text) {
      if (text === lessonPrompt || text === '') {
        this.setState({
          text: EditorState.createWithContent(convertFromHTML(text || '')),
        });
      }
    }
    if (boilerplate !== prevProps.boilerplate) {
      this.setState({ text: EditorState.createWithContent(convertFromHTML(boilerplate)), },
        () => {
          handleTextChange(convertToHTML(this.state.text.getCurrentContent()));
        }
      );
    }
  }

  handleTextChange(e) {
    this.setState({ text: e, }, () => {
      this.props.handleTextChange(convertToHTML(this.state.text.getCurrentContent()).replace(/<p><\/p>/g, '<br/>').replace(/&nbsp;/g, '<br/>'));
    });
  }

  render() {
    const { ItalicButton, BoldButton, UnderlineButton, BlockquoteButton, OLButton, ULButton, H4Button, MonospaceButton, InlineButton } = this.state.components;
    const textBoxClass = this.state.hasFocus ? 'card-content hasFocus' : 'card-content';
    return (
      <div className="card is-fullwidth">
        <header className="card-header">
          <div className="myToolbar">
            <p className="teacher-model-instructions">
              {this.props.title}
            </p>
            <div className="buttons-wrapper">
              <BoldButton />
              <ItalicButton />
              <UnderlineButton />
              <BlockquoteButton />
              <OLButton />
              <ULButton />
              <H4Button />
              <MonospaceButton><InlineButton className="alignLeft" title="Align Left" /></MonospaceButton>
            </div>
          </div>
        </header>
        <div className={textBoxClass}>
          <div className="content">
            <Editor
              editorState={this.state.text}
              onBlur={() => this.setState({ hasFocus: false, })}
              onChange={this.handleTextChange}
              onFocus={() => this.setState({ hasFocus: true, })}
              plugins={this.state.plugins}
            />
          </div>
        </div>
      </div>
    );
  }

}

export default MultipleTextEditor;
